<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M12.667 8.333a4.333 4.333 0 11-8.667 0 4.333 4.333 0 018.667 0zm-2 0a2.333 2.333 0 11-4.667 0 2.333 2.333 0 014.667 0z" clip-rule="evenodd"/><path d="M4.46 26.126L26.125 4.46a1 1 0 111.414 1.414L5.874 27.54a1 1 0 11-1.415-1.414z"/><path fill-rule="evenodd" d="M23.667 28a4.333 4.333 0 100-8.667 4.333 4.333 0 000 8.667zm0-2a2.333 2.333 0 100-4.667 2.333 2.333 0 000 4.667z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsPercentageOutline'
}
</script>
